import React, { useState, useEffect } from 'react';
import './ChannelMembersModal.css';

const ChannelMembersModal = ({
    isOpen,
    onClose,
    currentChannel,
    availableUsers,
    onAddMember,
    onRemoveMember
}) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);

    useEffect(() => {
        if (isOpen && availableUsers) {
            const currentMemberIds = currentChannel?.members || [];
            const currentMembers = getCurrentMembers();
            const currentMemberUserIds = currentMembers.map(member => member.id);
            const nonMembers = availableUsers.filter(user =>
                !currentMemberIds.includes(user.id) &&
                !currentMemberUserIds.includes(user.id) &&
                user.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredUsers(nonMembers);
        }
    }, [isOpen, availableUsers, currentChannel, searchQuery]);

    const handleAddMember = (user) => {
        onAddMember(user);
        setSearchQuery('');
    };

    const handleRemoveMember = (memberId) => {
        onRemoveMember(memberId);
    };

    const getAvatarInitial = (name) => {
        return name ? name.charAt(0).toUpperCase() : '?';
    };

    const getCurrentMembers = () => {
        if (!currentChannel?.members || !availableUsers) return [];
        return currentChannel.members.map((memberId, index) => {
            const user = availableUsers.find(u => String(u.id) === String(memberId));
            if (user) {
                return user;
            }
            return {
                id: memberId,
                name: currentChannel.members_name?.[index] || `User ${memberId}`,
                email: '',
            };
        });
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 style={{ fontWeight: '800' }}>{currentChannel?.name}</h2>
                    <button className="modal-close-btn" onClick={onClose} style={{ scale: "1.230" }}>×</button>
                </div>

                <div className="modal-body">
                    <div className="add-member-section">
                        <h3>Add Members</h3>
                        <div className="search-input-container">
                            <input
                                type="text"
                                className="member-search-input"
                                placeholder="Search users to add..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>

                        {searchQuery && (
                            <div className="search-results">
                                {filteredUsers.length > 0 ? (
                                    filteredUsers.map(user => (
                                        <div key={user.id} className="user-result-item">
                                            <div className="user-info">
                                                <div className="user-avatar">
                                                    {getAvatarInitial(user.name)}
                                                </div>
                                                <div className="user-details">
                                                    <span className="user-name">{user.name}</span>
                                                    <span className="user-email">{user.email}</span>
                                                </div>
                                            </div>
                                            <button
                                                className="add-member-btn"
                                                onClick={() => handleAddMember(user)}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-results">No users found</div>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="current-members-section">
                        <h3>Current Members ({getCurrentMembers().length})</h3>
                        <div className="members-list">
                            {getCurrentMembers().map(member => (
                                <div key={member.id} className="member-item">
                                    <div className="member-info">
                                        <div className="user-avatar">
                                            {getAvatarInitial(member.name)}
                                        </div>
                                        <div className="member-details">
                                            <span className="member-name">{member.name}</span>
                                            <span className="member-email">{member.email}</span>
                                        </div>
                                    </div>
                                    <button
                                        className="remove-member-btn"
                                        onClick={() => handleRemoveMember(member.id)}
                                        title="Remove member"
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                            {getCurrentMembers().length === 0 && (
                                <div className="no-members">No members in this channel</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="channel-modal-footer">
                    <button className="modal-cancel-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChannelMembersModal;